export default "__VITE_ASSET__0e22538c__"